var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFileCertificate = function SvgFileCertificate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3 6.9H12c-.2 0-.4-.2-.4-.4V1.1m5.7 20.8c0 .6-.4 1-1 1H1.8c-.5 0-.8-.4-.8-.8V1.8c0-.4.4-.8.8-.8h8.7v5.4c0 .8.6 1.4 1.4 1.4h5.4zm.8-15.7L12.2.3a.9.9 0 0 0-.7-.3H1.8C.8 0 0 .8 0 1.8v20.3c0 1 .8 1.8 1.8 1.8h14.7c1 0 1.8-.8 1.8-1.8V7c0-.2 0-.5-.2-.8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.2 6.6h6.5v1H2.2zm0 2.1H10v1H2.2zm0 2h6.5v1H2.2zm8.883 2.967V12.2l-1.583.733-1.583-.733v1.467l-1.584.733 1.584.733V16.6l1.583-.733 1.583.733v-1.467l1.584-.733zM7.917 21l1.583-.733 1.583.733v-3.667H7.917z"
  })));
};
export default SvgFileCertificate;